const { SCALING_FACTOR, SCORE_MAX } = require("./constant");

exports.arrayEquals = function (a, b) {
  return (
    Array.isArray(a) &&
    Array.isArray(b) &&
    a.length === b.length &&
    a.every((v) => b.indexOf(v) >= 0)
  );
};

exports.scaleRoundTo5 = function (x, scalingFactor = SCALING_FACTOR) {
  return parseInt(Math.round(Math.min(x / scalingFactor, SCORE_MAX) / 5) * 5);
};

exports.sumValues = (objects, requiredKeys) => {
  const result = {};
  objects.forEach((obj, idx) => {
    for (let key of requiredKeys) {
      const value = obj.hasOwnProperty(key) ? obj[key] : null;
      if (typeof value === "number") {
        if (result.hasOwnProperty(key)) {
          result[key] += value;
        } else {
          result[key] = value;
        }
      } else {
        throw Error(
          `Value for ${key} must be a number (In amounts array at index = ${idx}).`
        );
      }
    }
  });
  return result;
};
